import { render, staticRenderFns } from "./onlineBankDetails.vue?vue&type=template&id=6a4b0fc4&scoped=true"
import script from "./onlineBankDetails.vue?vue&type=script&lang=js"
export * from "./onlineBankDetails.vue?vue&type=script&lang=js"
import style0 from "./onlineBankDetails.vue?vue&type=style&index=0&id=6a4b0fc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b0fc4",
  null
  
)

export default component.exports